module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('AppSteppers', {
    attrs: {
      "start-step-name": "Данные пользователя"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var prevStep = ref.prevStep;
        var nextStep = ref.nextStep;

        return [_c('AppSteppersPane', {
          attrs: {
            "step-name": "Данные пользователя"
          }
        }, [_c('DynamicAdditionalDataForm', {
          attrs: {
            "next-step": nextStep
          }
        })], 1), (_vm.orderBinds.activity.isRequirements) ? _c('AppSteppersPane', {
          attrs: {
            "step-name": "Требования к участию"
          }
        }, [_c('ActivitiesOrderRequirements', {
          attrs: {
            "activity": _vm.orderBinds.activity,
            "next-step": nextStep,
            "next-call-back": _vm.requirementsNextStep
          }
        })], 1) : _vm._e(), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Оформление заявки"
          }
        }, [_c('ActivitesOrder', _vm._b({
          attrs: {
            "file": _vm.file,
            "answer": _vm.answer,
            "next-step": nextStep
          },
          on: {
            "sendResult": function($event) {
              return _vm.setFinishMsg($event)
            }
          }
        }, 'ActivitesOrder', _vm.orderBinds, false))], 1), _c('AppSteppersPane', {
          attrs: {
            "step-name": "Статус"
          }
        }, [_c('FinishMessage', {
          attrs: {
            "message": _vm.finishMsg,
            "close-modal": function () { return _vm.$ui.$modal.close("activityOrderProcess"); }
          }
        })], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fbd2028","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ordersProcessForms/activity/ActivityOrderProcess.vue
// module id = efec6c26d9b3501810b4
// module chunks = 20